import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { User } from '/app/models/user';
// import { environment } from '/app/environments/environment';



import { environment } from '/app/environments/environment';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

// Agrega esta interfaz para la respuesta del login
interface LoginResponse {
  idToken: string;
  accessToken: string;
  // Agrega otras propiedades que pueda tener la respuesta
  [key: string]: any; // Para propiedades adicionales
}

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private loggedIn = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.loggedIn.asObservable();

  constructor(private http: HttpClient) { }

  login(email: string): Observable<any> {
    const requestBody = { email: email };
    const sessionLogin = this.http.post(
      `${environment.api}/auth/request-otp`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return sessionLogin;
  }

  verifyOtp(email: string, otp: string, session: string): Observable<LoginResponse> {
    const requestBody = {
      email: email,
      otp: otp,
      session: session
    };

    return this.http.post<LoginResponse>(
      `${environment.api}/auth/login`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*'
        }
      }
    ).pipe(
      tap(response => {
        // Verifica si existe accessToken en la respuesta
        if (response && response.idToken) {
          // Decodifica el token
          const decodedToken = this.decodeToken(response.idToken);
          const decodedToken2 = this.decodeToken(response.idToken);
          this.setIdToken(response.idToken);
          // Almacena el token
          this.setToken(response.accessToken);

          // Establece el estado de loggedIn a true
          this.setLoggedIn(true);
        }
      })
    );
  }

  getUserInfo() {
    const token = this.getIdToken();
    if (!token) return null;

    const decoded = this.decodeToken(token);

    const groups = decoded["cognito:groups"] || [];
    const fullName = `${decoded["name"] ?? ""} ${decoded["family_name"] ?? ""}`.trim();

    return {
      groups,
      fullName,
      email: decoded["email"],
      
    };
  }



  // ... el resto de tus métodos permanece igual
  setToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  setIdToken(idToken: string) {
    localStorage.setItem('id_token', idToken);
  }

  getToken(): string {
    return localStorage.getItem('access_token') ?? '';
  }

  getIdToken(): string {
    return localStorage.getItem('id_token') ?? '';
  }
  removeToken() {
    localStorage.removeItem('access_token');
  }

  canActivate(): boolean {
    const token = this.getToken();
    if (!token || token === '') return false;
    if (this.isTokenValid(token)) {
      return true;
    } else {
      this.removeToken();
      return false;
    }
  }

  decodeToken(token: string): any {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  }

  isTokenExpired(token: string): boolean {
    const decodedToken = this.decodeToken(token);
    const now = Date.now().valueOf() / 1000;
    return decodedToken.exp < now;
  }

  isTokenValid(token: string) {
    if (!token || token === '') return false;
    return !this.isTokenExpired(token);
  }

  setLoggedIn(value: boolean) {
    this.loggedIn.next(value);
  }

  logout() {
    this.removeToken();
    this.setLoggedIn(false);
  }

  getUsers(): Observable<any> {
    return this.http.get(environment.api + "/users/all");
  }
}